import { ProjectSettingCodeType } from 'data/types';
import { CustomerPreferenceQuestion } from './customer-preference-questions-types';

export const THERMOSTAT_DETAILS_TRIGGER = 'Want a Specific Smart Thermostat';

// Merch §9 customer-preference questions (AHA-6796, collect-only): answers
// ride the normal project-settings autosave; nothing filters, scores, or
// gates off them beyond the confidence score. The casts cover the new codes
// until the pinned @alpinehomeair/common (1.0.277) republishes with the enum
// members — remove them then. installation_timeline needs no cast (already
// shipped).
export const CUSTOMER_PREFERENCE_QUESTIONS: CustomerPreferenceQuestion[] = [
  {
    kind: 'question',
    code: 'desired_efficiency_tier' as ProjectSettingCodeType,
    question: 'How efficient should the system be?'
  },
  {
    kind: 'question',
    code: 'budget_tier' as ProjectSettingCodeType,
    question: 'What budget tier fits best?'
  },
  {
    kind: 'question',
    code: 'system_fuel_intent' as ProjectSettingCodeType,
    question: 'Cooling only, or heat pump too?'
  },
  {
    kind: 'question',
    code: 'thermostat_preference' as ProjectSettingCodeType,
    question: 'Thermostat preference?'
  },
  {
    kind: 'question',
    code: 'thermostat_details' as ProjectSettingCodeType,
    question: 'Which thermostat?',
    debounce: 500,
    visibleWhen: {
      code: 'thermostat_preference' as ProjectSettingCodeType,
      value: THERMOSTAT_DETAILS_TRIGGER
    }
  },
  {
    kind: 'checkbox-group',
    question: 'What comfort issues matter most?',
    codes: [
      'comfort_priority_better_heating' as ProjectSettingCodeType,
      'comfort_priority_humidity_control' as ProjectSettingCodeType,
      'comfort_priority_uneven_rooms' as ProjectSettingCodeType,
      'comfort_priority_noise' as ProjectSettingCodeType
    ]
  },
  {
    kind: 'question',
    code: 'ductless_openness' as ProjectSettingCodeType,
    question: 'Open to ductless equipment?'
  },
  {
    kind: 'question',
    code: 'installation_timeline',
    question: 'When do you need this installed?'
  },
  {
    kind: 'question',
    code: 'rebate_interest' as ProjectSettingCodeType,
    question: 'Interested in rebates?'
  }
];
